import type { SupportedLocale } from "./locales";

type MediaCopy = {
  play: string;
  download: string;
  redownload: string;
  expired: string;
  explanation: string;
  resolving: string;
  started: string;
  unavailable: string;
  private: string;
  temporary: string;
  incomplete: string;
  retry: string;
  check: string;
};
export const mediaRetentionCopy: Record<SupportedLocale, MediaCopy> = {
  en: {
    play: "Play video",
    download: "Download video",
    redownload: "Re-download video",
    expired: "Cached video expired",
    explanation: "We remove cached videos after 15 days without use. Your transcript is still available.",
    resolving: "Finding the video…",
    started: "Download started",
    unavailable: "This post is no longer available on Instagram. Your saved transcript is still available.",
    private: "This Instagram post is private or restricted. We can’t download its video.",
    temporary: "We couldn’t reach Instagram right now. Please try again.",
    incomplete: "The video transfer was interrupted. Please try again.",
    retry: "Try again",
    check: "Check again",
  },
  es: {
    play: "Reproducir video",
    download: "Descargar video",
    redownload: "Volver a descargar",
    expired: "El video en caché ha caducado",
    explanation: "Eliminamos los videos en caché tras 15 días sin uso. Tu transcripción sigue disponible.",
    resolving: "Buscando el video…",
    started: "Descarga iniciada",
    unavailable: "Esta publicación ya no está disponible en Instagram. Tu transcripción sigue disponible.",
    private: "Esta publicación es privada o está restringida. No podemos descargar el video.",
    temporary: "No pudimos conectar con Instagram. Inténtalo de nuevo.",
    incomplete: "Se interrumpió la descarga. Inténtalo de nuevo.",
    retry: "Reintentar",
    check: "Comprobar de nuevo",
  },
  fr: {
    play: "Lire la vidéo",
    download: "Télécharger la vidéo",
    redownload: "Télécharger à nouveau",
    expired: "La vidéo en cache a expiré",
    explanation: "Nous supprimons les vidéos en cache après 15 jours sans utilisation. Votre transcription reste disponible.",
    resolving: "Recherche de la vidéo…",
    started: "Téléchargement démarré",
    unavailable: "Cette publication n’est plus disponible sur Instagram. Votre transcription reste disponible.",
    private: "Cette publication est privée ou restreinte. Nous ne pouvons pas télécharger sa vidéo.",
    temporary: "Instagram est momentanément inaccessible. Veuillez réessayer.",
    incomplete: "Le transfert a été interrompu. Veuillez réessayer.",
    retry: "Réessayer",
    check: "Vérifier à nouveau",
  },
  de: {
    play: "Video abspielen",
    download: "Video herunterladen",
    redownload: "Erneut herunterladen",
    expired: "Zwischengespeichertes Video abgelaufen",
    explanation: "Wir entfernen zwischengespeicherte Videos nach 15 Tagen ohne Nutzung. Dein Transkript bleibt verfügbar.",
    resolving: "Video wird gesucht…",
    started: "Download gestartet",
    unavailable: "Dieser Beitrag ist auf Instagram nicht mehr verfügbar. Dein Transkript bleibt verfügbar.",
    private: "Dieser Beitrag ist privat oder eingeschränkt. Das Video kann nicht heruntergeladen werden.",
    temporary: "Instagram ist gerade nicht erreichbar. Bitte versuche es erneut.",
    incomplete: "Die Übertragung wurde unterbrochen. Bitte versuche es erneut.",
    retry: "Erneut versuchen",
    check: "Erneut prüfen",
  },
  it: {
    play: "Riproduci video",
    download: "Scarica video",
    redownload: "Scarica di nuovo",
    expired: "Video nella cache scaduto",
    explanation: "Rimuoviamo i video dalla cache dopo 15 giorni senza utilizzo. La trascrizione resta disponibile.",
    resolving: "Ricerca del video…",
    started: "Download avviato",
    unavailable: "Questo post non è più disponibile su Instagram. La trascrizione resta disponibile.",
    private: "Questo post è privato o con accesso limitato. Non possiamo scaricare il video.",
    temporary: "Non riusciamo a contattare Instagram. Riprova più tardi.",
    incomplete: "Il trasferimento è stato interrotto. Riprova.",
    retry: "Riprova",
    check: "Controlla di nuovo",
  },
  pt: {
    play: "Reproduzir vídeo",
    download: "Baixar vídeo",
    redownload: "Baixar novamente",
    expired: "Vídeo em cache expirado",
    explanation: "Removemos vídeos em cache após 15 dias sem uso. Sua transcrição continua disponível.",
    resolving: "Buscando o vídeo…",
    started: "Download iniciado",
    unavailable: "Esta publicação não está mais disponível no Instagram. Sua transcrição continua disponível.",
    private: "Esta publicação é privada ou restrita. Não podemos baixar o vídeo.",
    temporary: "Não foi possível acessar o Instagram. Tente novamente.",
    incomplete: "A transferência foi interrompida. Tente novamente.",
    retry: "Tentar novamente",
    check: "Verificar novamente",
  },
};
